import { render, staticRenderFns } from "./DashboardSupport.vue?vue&type=template&id=1c772195&"
import script from "./DashboardSupport.vue?vue&type=script&lang=js&"
export * from "./DashboardSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c772195')) {
      api.createRecord('1c772195', component.options)
    } else {
      api.reload('1c772195', component.options)
    }
    module.hot.accept("./DashboardSupport.vue?vue&type=template&id=1c772195&", function () {
      api.rerender('1c772195', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/support/DashboardSupport.vue"
export default component.exports